import { styled } from '@mui/material'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
const TableBibliotecario = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal',
    '&:nth-of-type(4)': {
      textAlign: 'center!important'
    }
  }
}))

export default TableBibliotecario
